import React from 'react';
import { Steps } from 'antd';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { commafy } from 'helpers/number';
import SectionContainer from 'components/Containers/SectionContainer';
import './ActionPlan.scss';
import { formatNumber2Decimal } from 'helpers/number';

const StepIcon = () => <div className="stepsCheckMark" />;
const StepTitle = ({ title }) => (
  <Label type="Subtitle-1" className="inline">
    <strong>{title}</strong>
  </Label>
);
const StepDescription = ({ description }) => (
  <Label className="Body-1">{description}</Label>
);

const ActionPlan = ({
  actionPlanTitle = 'Your action plan',
  subTitle = 'Aim for credit utilization of under 10% across all your credit cards by taking these recommended actions.',
  ...props
}) => {
  const currentCreditLimitUsage = commafy(
    formatNumber2Decimal(props?.currentCreditUsageLimit),
  );
  const stepStatus = 'finish';
  return (
    <SectionContainer className="ActionPlan">
      <Row className="bgWhite">
        <Label type="H4" typeHeader={'h4'}>
          {actionPlanTitle}
        </Label>
        <hr className="borderGray050 margb16" />
        <Label type="Body-1 margb20">{subTitle}</Label>
        <Steps direction="vertical" current={0}>
          <Steps.Step
            icon={<StepIcon />}
            status={stepStatus}
            title={<StepTitle title="Reduce your spending on credit." />}
            description={
              <StepDescription description="Spend no more than $100 for every $1,000 credit available on your credit cards." />
            }
          />
          <Steps.Step
            icon={<StepIcon />}
            status={stepStatus}
            title={<StepTitle title="Lower your credit balance." />}
            description={
              <StepDescription
                description={`Make payments several times per month to keep your credit balance under $${currentCreditLimitUsage}.`}
              />
            }
          />
          <Steps.Step
            icon={<StepIcon />}
            status={stepStatus}
            title={
              <StepTitle title="Contact card providers and ask to raise your credit limit." />
            }
            description={
              <StepDescription description="Try to Keep a higher credit limit and lower credit usage to keep your credit score in a good state." />
            }
          />
          <Steps.Step
            icon={<StepIcon />}
            status={stepStatus}
            title={<StepTitle title="Increase your credit limit." />}
            description={
              <StepDescription
                description={`Based on our estimations, if you are in the market to get a new card and can add around $${commafy(
                  props?.offerMaxLimit,
                )} to your credit limit, it could reduce your overall credit usage.`}
              />
            }
          />
          <Steps.Step
            icon={<StepIcon />}
            status={stepStatus}
            title={<StepTitle title="Ask to become an authorized user." />}
            description={
              <StepDescription description="If you are new to credit, you can always ask a trusted friend or family member with a good credit score to add you as an authorized user so you can benefit from their credit management skills." />
            }
          />
        </Steps>
      </Row>
    </SectionContainer>
  );
};

export default ActionPlan;
